module.exports = __webpack_public_path__ + "media/images/banner_institucional-7933745ddc0b541572fbbd0790586253.png";